import React, { useContext } from 'react';
import { AppConfigContext } from '../../Config/App';
import { LanguageContext } from '../../Data/Context/languageContext';
import uuid from 'uuidv4';

const DropDownDark = ({ classes, changeLanguage, dropDownList }) => {
    const { assets_url } = useContext(AppConfigContext);
    const { handleChangeLanguage } = useContext(LanguageContext);
    const current_lng = localStorage.getItem("lng_full");
    const current_flag = localStorage.getItem("flag");

    return (
        <>
            <div className={`${classes}`}>
                <button className="btn btn-secondary dropdown-toggle purple-bk" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    {current_lng ? current_lng : "English"}
                    {changeLanguage &&
                        <img loading="lazy" className='ms-3 country-flag' alt='Pokeland Legends' src={assets_url(current_flag ? current_flag : "flags/en.webp")}></img>
                    }
                </button>

                <ul className='dropdown-menu dropdown-menu-dark purple-bk'>
                    {dropDownList && dropDownList.map((itemList) => {
                        return (
                            <li key={uuid()} onClick={() => changeLanguage ? handleChangeLanguage(itemList.lng, itemList.text, itemList.img) : ''}>
                                <span className='dropdown-item d-flex justify-content-between px-2 selectLgn'>
                                    {itemList.text}
                                    <img loading="lazy" className='ms-3' alt='Pokeland Legends' src={assets_url(itemList.img)}></img>
                                </span>
                            </li>
                        )
                    })}
                </ul>
            </div>
        </>
    );
}
export default DropDownDark;